import httpClient from '@/services/httpClient'
import {
  CareEndpoints,
  ICareFilters,
  ICareItem,
  ICareListResponse,
  ICareStatus,
  IHealthCareStatus,
} from './types'
import { mockCareItems } from './hooks/useCreateCareItemsMock'
import { UpcomingConsultationMapper } from '../MyCalls/mappers/UpcomingConsultationMapper'
import { CareFakedoorActions } from './components/CareFakedoorModal/CareFakedoorModal.types'

export const getHealthCareStatus = async (): Promise<IHealthCareStatus> => {
  const { data } = await httpClient.get(CareEndpoints.HealthCare)
  return data.object
}

export const createHealthCare = async (): Promise<IHealthCareStatus> => {
  const { data } = await httpClient.post(CareEndpoints.HealthCare)
  return data.object
}

export const getCareFeatureFlag = async (): Promise<boolean> => {
  const { data } = await httpClient.get(CareEndpoints.GetCareFeatureFlag)
  return data.object
}

export const getCareList = async (
  useMock: boolean,
  filters: ICareFilters,
): Promise<ICareListResponse> => {
  if (useMock) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          total: 50,
          today: mockCareItems(20),
          upcoming: mockCareItems(15),
          later: mockCareItems(25),
        })
      }, 2000)
    })
  }

  const params: { [key: string]: string } = {
    tab: filters.tab.toUpperCase(),
    search: filters.search,
  }

  if (filters.type.length > 0) {
    params.type = filters.type.map(type => type.value.toUpperCase()).join(',')
  }

  if (filters.status.length > 0) {
    params.status = filters.status
      .map(status => status.value.toUpperCase())
      .join(',')
  }

  const { data } = await httpClient.get(CareEndpoints.GetCareList, {
    params,
  })

  function mapAppointmentsMetadata(array) {
    if (!array) return array
    return array.map(item => {
      if (item.appointment?.metadata) {
        return {
          ...item,
          appointment: {
            ...item.appointment,
            metadata: UpcomingConsultationMapper.toDomain(
              item.appointment.metadata,
            ),
          },
        }
      }
      return item
    })
  }

  data.object.today = mapAppointmentsMetadata(data.object.today)
  data.object.upcoming = mapAppointmentsMetadata(data.object.upcoming)
  data.object.later = mapAppointmentsMetadata(data.object.later)

  return data.object
}

export const changeCareStatus = async (
  careId: string,
  status: ICareStatus,
  date?: string,
): Promise<ICareItem> => {
  const { data } = await httpClient.put(
    CareEndpoints.ChangeCareStatus + '/' + careId,
    {
      status: status.toUpperCase(),
      date,
    },
  )

  if (data.object.appointment) {
    data.object.appointment.metadata = UpcomingConsultationMapper.toDomain(
      data.object.appointment.metadata,
    )
  }

  return data.object
}

export const requestFakeDoorInsights = async ({
  comment,
  type,
}: {
  comment?: string
  type: CareFakedoorActions
}): Promise<void> => {
  const { data } = await httpClient.post(CareEndpoints.PostFakeDoorInsights, {
    ...(comment ? { comment: comment.trim() } : {}),
    type,
  })

  return data.object
}
